import bootcampImg from "../assets/bootcamp.jpg";
import hackathonImg from "../assets/hackathon.jpg";
import workshopImg from "../assets/workshop.jpg";
import researchImg from "../assets/research.jpg";
import {
  GraduationCap,
  Lightbulb,
  Wrench,
  Microscope,
} from "lucide-react";

const programs = [
  {
    title: "Bootcamps",
    description:
      "Intensive learning experiences designed to build practical AI and digital skills in a short time.",
    icon: GraduationCap,
    image: bootcampImg,
  },
  {
    title: "Hackathons",
    description:
      "Collaborative innovation challenges where participants solve real problems using technology and AI.",
    icon: Lightbulb,
    image: hackathonImg,
  },
  {
    title: "Workshops",
    description:
      "Hands-on sessions that introduce learners and professionals to practical tools, concepts, and applications.",
    icon: Wrench,
    image: workshopImg,
  },
  {
    title: "Research Labs",
    description:
      "Exploration spaces for developing new ideas, testing solutions, and advancing knowledge in AI and emerging technologies.",
    icon: Microscope,
    image: researchImg,
  },
];

export default function Programs() {
  return (
    <section
      id="programs"
      className="relative bg-black text-white py-24 px-6 overflow-hidden"
    >
      {/* background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-16 left-1/4 w-64 h-64 rounded-full bg-yellow-400/10 blur-3xl" />
        <div className="absolute bottom-12 right-1/4 w-72 h-72 rounded-full bg-yellow-500/10 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-yellow-400 mb-6 drop-shadow-[0_0_15px_rgba(250,204,21,0.35)]">
          Programs
        </h2>

        <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-16">
          Our programs are designed to equip learners, innovators, and
          organizations with practical knowledge, collaborative experiences,
          and opportunities to build with AI.
        </p>

        <div className="grid md:grid-cols-2 gap-8">
          {programs.map((program, index) => {
            const Icon = program.icon;

            return (
              <div
                key={index}
                className="group bg-[#0a0a0a] border border-yellow-400/10 rounded-3xl overflow-hidden text-left transition duration-500 hover:-translate-y-2 hover:shadow-[0_0_28px_rgba(250,204,21,0.14)]"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={program.image}
                    alt={program.title}
                    className="w-full h-56 object-cover transition duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />

                  <div className="absolute top-4 left-4 flex items-center justify-center w-14 h-14 rounded-2xl bg-black/60 border border-yellow-400/20 backdrop-blur-sm">
                    <Icon className="text-yellow-400" size={26} />
                  </div>
                </div>

                <div className="p-8">
                  <h3 className="text-2xl font-bold text-yellow-400 mb-3 tracking-wide">
                    {program.title}
                  </h3>

                  <div className="w-16 h-[2px] bg-yellow-400 mb-4 opacity-70" />

                  <p className="text-gray-300 text-base md:text-lg leading-relaxed">
                    {program.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}